import { render, staticRenderFns } from "./rootModal.vue?vue&type=template&id=ff4fb660&scoped=true&"
import script from "./rootModal.vue?vue&type=script&lang=ts&"
export * from "./rootModal.vue?vue&type=script&lang=ts&"
import style1 from "./rootModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4fb660",
  null
  
)

export default component.exports